<template>
<div>
    <header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Rangliste</h1>
    </header>
    <section>
        <header>
            <div class="choice">
                <router-link :to="`/users/${userId}/ranking/global`" replace v-bind:class="{ 'btn-secondary': $route.params.type == 'global' }">
                    Weltweit
                </router-link>
                <router-link :to="`/users/${userId}/ranking/city`" v-if="who.city" replace
                             v-bind:class="{ 'btn-secondary': $route.params.type == 'city' }">
                    {{ who.city.name }}
                </router-link>
                <router-link :to="`/users/${userId}/ranking/friends`" replace v-bind:class="{ 'btn-secondary': $route.params.type == 'friends' }">
                    Freunde
                </router-link>
                <router-link :to="`/users/${userId}/ranking/year`" v-if="who.year" replace
                             v-bind:class="{ 'btn-secondary': $route.params.type == 'year' }">
                    {{ who.year | grade }}. Klasse
                </router-link>
                <router-link :to="`/users/${userId}/ranking/school`" v-if="who.school" replace
                             v-bind:class="{ 'btn-secondary': $route.params.type == 'school' }">
                    {{ who.school.name }}
                </router-link>
            </div>
        </header>
        <ol class="ranking">
            <li v-for="player in ranking" :class="{ highlight: player.id == userId }">
                <router-link :to="`/profile/${player.id}`" class="item">
                    <dp :who="player" />
                    <div class="rank-change" v-if="player.rank_prev !== null && player.rank_prev > player.rank">
                        {{ player.rank_prev - player.rank }} ⬆️
                    </div>
                    <div class="rank-change" v-if="player.rank_prev !== null && player.rank_prev < player.rank">
                        {{ player.rank - player.rank_prev }} ⬇️
                    </div>
                    <h3>
                        {{ player | name }}
                    </h3>
                    <p class="elo">
                        ELO: {{ player.elo }}
                    </p>
                </router-link>
            </li>
        </ol>
    </section>
</div>
</template>

<script>
import _ from 'underscore'
import base from 'base.vue'
import dp from 'components/dp.vue'

export default {
    mixins: [ base ],
    components: { 'dp': dp },
    data () {
        return {
            ranking: [],
            who: {}
        }
    },
    computed: {
        userId () {
            return this.$route.params.user
        },
        type () {
            return this.$route.params.type
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.params.type) {
                this.fetchData()
            }
        }
    },
    methods: {
        fetchData () {
            const that = this
            
            return this.$api.get(`users/${this.$route.params.user}/ranking/${this.$route.params.type}`)
            .then(response => {
                that.ranking = response.data.ranking
                that.who = response.data.user
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// ranking.vue?a8da783e